import * as Yup from "yup";

const ValidationResponseReclamation = Yup.object().shape({
  responseAdmin: Yup.string().required(
    "A resposta é obrigatória para finalização do registro."
  ),
});

export default ValidationResponseReclamation;
